import { ButtonColors } from 'types';
import { Flex } from 'components/flex';
import { Link } from 'components/link';
import { Icon } from 'components/icon';
import { formatDate } from 'utils/date';
import { Button } from 'components/button';
import { InfoBlock } from 'components/info-block';
import { PayoutStatusBadge } from 'components/payout-status-badge';

import * as Styles from './styles';
import { Card, Price } from './card';
import { PayoutInfoProps } from './types';

export const PayoutInfo = ({
  payout,
  totalPrice,
  onBackClick,
  showPayoutPrice,
}: PayoutInfoProps) => {
  const paymentMethodName =
    payout?.payout?.paymentMethod?.name || payout?.paymentMethod?.name;

  return (
    <Flex gap={16} fullWidth flexDirection="column">
      {!!onBackClick && (
        <div>
          <Button
            padding="0"
            onClick={onBackClick}
            icon={<Icon.ChevronLeft />}
            text={`Payroll #${payout?.id}`}
            colorType={ButtonColors.Transparent}
          />
        </div>
      )}
      <Styles.Title>
        Event: <span className="semibold">{payout?.event?.name}</span>
      </Styles.Title>

      <Flex gap={8} flexDirection="column">
        <InfoBlock>
          <Flex gap={16} flexDirection="column">
            <Card title="Employee name" value={payout?.employee?.user?.name} />
            <Card title="Date" value={formatDate(payout?.date)} />
            {payout?.status && (
              <Card
                title="Status"
                value={
                  <PayoutStatusBadge
                    type={payout.type}
                    status={payout.status}
                  />
                }
              />
            )}
            <Card
              value={paymentMethodName || payout?.type}
              title={paymentMethodName ? 'Payment Method' : 'Type'}
            />
            {payout?.receiptUrl && (
              <Card
                title="Receipt"
                value={
                  <Link withoutButton text="Download" url={payout.receiptUrl} />
                }
              />
            )}
            <Card title="Notes" value={payout?.notes} />
          </Flex>
        </InfoBlock>
        <Price
          payout={payout}
          totalPrice={totalPrice}
          showPayoutPrice={showPayoutPrice}
        />
      </Flex>
    </Flex>
  );
};
